import React from 'react';
import { useI18n } from '../../contexts/I18nContext';
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  const { t } = useI18n();
  const today = '2026-04-15';
  const sections = Array.from({ length: 8 }, (_, index) => {
    const sectionNumber = index + 1;
    return {
      title: t(`catoo.privacyPolicyPage.section${sectionNumber}Title`),
      content: t(`catoo.privacyPolicyPage.section${sectionNumber}Content`),
    };
  });

  return (
    <div className="privacy-policy-page">
      <div className="container">
        <div className="policy-content">
          <h1>{t('catoo.privacyPolicy')}</h1>
          <p>{t('catoo.privacyPolicyPage.lastUpdated', { date: today })}</p>
          <p className="policy-text">{t('catoo.privacyPolicyPage.intro')}</p>

          {sections.map((section) => (
            <React.Fragment key={section.title}>
              <h2>{section.title}</h2>
              <p className="policy-text">{section.content}</p>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
